<!--  -->
<template>
    <div>
        <div class="table-top">
            <el-button v-if="!disabled" @click="addRow">添加一行</el-button>
        </div>
        <div class="list_content">
            <div v-for="(item, index) in tableData" :key="item.id" class="list_item">
                <el-form ref="form" label-width="120px">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="商品来源">
                                <el-select placeholder="请选择商品来源" v-model="item.productSource"
                                    @change="(e) => sourceChange(index, e)" :disabled="disabled">
                                    <el-option v-for="oitem in item.options" :key="oitem.dictCode"
                                        :label="oitem.dictValue" :value="oitem.dictCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="产品名称">
                                <el-input v-if="item.productSource === '2'" :disabled="disabled"
                                    v-model="item.productName" placeholder="请输入产品名称"></el-input>
                                <div @click="openModal(index)" v-else-if="item.productSource === '1'"
                                    style="width: 100%;">
                                    <el-input readonly v-model="item.productName" placeholder="请选择产品名称"
                                        :disabled="disabled" @change="(e) => changeEvent()"></el-input>
                                </div>
                                <el-input v-else :disabled="disabled" v-model="item.productName" placeholder="请输入产品名称"
                                    @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="产品编码">
                                <el-input v-if="item.productSource === '2'" :disabled="disabled"
                                    v-model="item.productCode" placeholder="请输入产品编码"
                                    @change="(e) => changeEvent()"></el-input>
                                <el-input v-else-if="item.productSource === '1'" readonly disabled
                                    v-model="item.productCode" placeholder="请输入产品编码"
                                    @change="(e) => changeEvent()"></el-input>
                                <el-input v-else readonly disabled v-model="item.productCode" placeholder="请输入编码编码"
                                    @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="规格">
                                <el-input v-if="item.productSource === '2'" :disabled="disabled"
                                    v-model="item.specification" placeholder="请输入规格"
                                    @change="(e) => changeEvent()"></el-input>
                                <el-input v-else-if="item.productSource === '1'" readonly disabled
                                    v-model="item.specification" placeholder="请输入规格"
                                    @change="(e) => changeEvent()"></el-input>
                                <el-input v-else readonly disabled v-model="item.specification" placeholder="请输入规格"
                                    @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品分类">
                                <el-select placeholder="请选择商品分类" v-model="item.displayType" :disabled="disabled"
                                    @change="(e) => changeEvent()">
                                    <el-option v-for="pitem in item.calssOptions" :key="pitem.dictCode"
                                        :label="pitem.dictValue" :value="pitem.dictCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品层级">
                                <el-input v-if="item.productSource === '2'" :disabled="disabled"
                                    v-model="item.productHierarchy" placeholder="请输入商品层级"
                                    @change="(e) => changeEvent()"></el-input>
                                <el-input v-else-if="item.productSource === '1'" readonly disabled
                                    v-model="item.productHierarchy" placeholder="请输入商品层级"
                                    @change="(e) => changeEvent()"></el-input>
                                <el-input v-else readonly disabled v-model="item.productHierarchy"
                                    placeholder="请输入商品层级"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <el-form-item label="开始时间">
                                <el-date-picker v-model="item.startTime" type="datetime" placeholder="选择开始时间"
                                    :disabled="disabled" value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="(e) => changeEvent()">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="结束时间">
                                <el-date-picker v-model="item.endTime" type="datetime" placeholder="选择开始时间"
                                    :disabled="disabled" value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="(e) => changeEvent()">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="购买单位">
                                <el-input :disabled="disabled" v-model="item.unit" placeholder="请输入购买单位"
                                    @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品兑换积分">
                                <el-input :disabled="disabled" v-model="item.integral" placeholder="请输入商品兑换积分"
                                    @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="productType === '3'">
                        <el-col :span="8">
                            <el-form-item label="现金下单奖励积分" label-width="160px">
                                <el-input :disabled="disabled" v-model="item.rewardPoint" placeholder="请输入奖励积分"
                                    @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品原价/元">
                                <el-input type="number" :disabled="disabled" placeholder="请输入商品原价" v-model="item.price"
                                    @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品会员价/元">
                                <el-input type="number" :disabled="disabled" placeholder="请输入商品会员价"
                                    v-model="item.memberPrice" @change="(e) => changeEvent()"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="商品列表图(1张)">
                                <UploadImage @change="(files) => changeFiles(files, index, 'one')"
                                    :value="item.imageList" :disabled="disabled">
                                </UploadImage>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item label="详情图(最多10张)">
                                <UploadImage @change="(files) => changeFiles(files, index, 'two')" :limit="10"
                                    :value="item.detailedPicture" :disabled="disabled">
                                </UploadImage>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
    </div>
</template>

<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import { e } from 'mathjs';
import UploadImage from './upload_image.vue';

export default {
  components: { UploadImage, SelectConfig },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    productTypeFlag: {
      type: String,
    },
    fApi: Object,
    getValue: Function,

  },
  data() {
    return {
      sourceOptions: [],
      calssOptionsList: [],
      lineIndex: 0,
      productType: '',
      sourceVal: '',
      tableData: [],
    };
  },
  computed: {},
  methods: {
    // 获取跳转页面字典值
    getDioct() {
      const param = ['member_commodity_surcoe', 'member_commodity_type', 'member_commodity_calss'];
      request
        .post('/mdm/mdmdictdata/batchDictSelect', param)
        .then((res) => {
          if (!res.success) return this.$message.error(res.message);
          this.sourceOptions = res.result.member_commodity_surcoe;
          this.calssOptionsList = res.result.member_commodity_calss;
        });
    },
    // 选择来源
    sourceChange(index, val) {
      console.log(index, val);

      if (val === this.sourceVal) return false;
      this.sourceVal = val;
      this.tableData[index].productCode = null;
      this.tableData[index].productName = null;
      this.tableData[index].specification = null;
      this.tableData[index].productHierarchy = null;
      this.changeEvent();
    },
    openModal(index) {
      this.lineIndex = index;
      console.log('2222');
      const params = {
        functionCode: 'productList',
        noReset: true,
        paramData: {
          enableStatus: '009',
          delFlag: '009',
        },
        pageAble: false,
        data: [],
        selectionList: [],
        idKey: 'productCode',
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      console.log('onGetSelect ~ val:', val);
      console.log('lineIndex', this.lineIndex);
      this.tableData[this.lineIndex].productCode = val[0].productCode;
      this.tableData[this.lineIndex].productName = val[0].productName;
      this.tableData[this.lineIndex].specification = val[0].spec;
      this.tableData[this.lineIndex].productHierarchy = val[0].productLevelName;
      this.changeEvent();
    },
    // 行删除
    deleteItem(index) {
      this.list.splice(index, 1);
      this.toFather();
    },
    removeEvent(row) {
      this.tableData = this.tableData.filter((item) => item.id !== row.id);
      this.changeEvent();
    },
    addRow() {
      const productType = this.getValue('productType');
      this.productType = productType;
      console.log(productType);
      if (!productType) {
        this.$message.error('请选择商品类型');
        return false;
      }
      if (productType === '1') {
        if (this.tableData.length === 1) {
          this.$message.error('积分商品最多添加一条商品细类');
          return false;
        }
      }
      if (productType === '2') {
        if (this.tableData.length === 1) {
          this.$message.error('展示商品最多添加一条商品细类');
          return false;
        }
      }

      this.tableData.push({
        productIntegralCode: '',
        productSource: '',
        productCode: '',
        productName: '',
        specification: '',
        integral: '',
        displayType: '',
        productHierarchy: '',
        startTime: '',
        endTime: '',
        unit: '',
        price: '',
        memberPrice: '',
        rewardPoint: '',
        imageList: [],
        detailedPicture: [],
        options: this.sourceOptions,
        calssOptions: this.calssOptionsList,
        id: new Date().getTime() + Math.random() * 10000,
      });

      this.changeEvent();
    },

    changeFiles(files, index, type) {
      const productIntegralCode = this.getValue('productIntegralCode');
      console.log(files, index, type, this.tableData);
      if (type === 'one') {
        const imgs = [];
        files.forEach((item, oneIndex) => {
          imgs.push({
            productIntegralCode: productIntegralCode || '',
            urlPath: item.url,
            urlType: '1',
            number: oneIndex,
            ...item,
          });
        });
        this.tableData[index].imageList = imgs;
      }
      if (type === 'two') {
        const imgList = [];
        files.forEach((item, twoIndex) => {
          console.log('iitem', item);
          imgList.push({
            productIntegralCode: productIntegralCode || ' ',
            urlPath: item.url,
            urlType: '3',
            number: twoIndex,
            ...item,
          });
        });
        this.tableData[index].detailedPicture = imgList;
      }
      //   this.tableData = this.tableData.map((el) => {
      //     if (el.id === row.id) {
      //       el.url = files[0] ? files[0].url : '';
      //     }
      //     return {
      //       ...el,
      //     };
      //   });
      this.changeEvent();
    },
    /* eslint-disable no-param-reassign */
    /* eslint-enable no-param-reassign */
    changeEvent() {
      this.$emit('change', this.tableData);
      this.$emit('input', this.tableData);
    },

  },

  watch: {
    value: {
      deep: true,
      immediate: false,
      handler(val) {
        if (val) {
          val.forEach((eitem) => {
            const ci = eitem;
            ci.options = this.sourceOptions;
            ci.calssOptions = this.calssOptionsList;
            if (ci.imageList) {
              ci.imageList.forEach((ct) => {
                const cc = ct;
                cc.url = cc.urlPath;
              });
            }
            if (ci.detailedPicture) {
              ci.detailedPicture.forEach((cr) => {
                const cp = cr;
                cp.url = cp.urlPath;
              });
            }
          });
          this.tableData = val;
        }
      },
    },
    productTypeFlag: {
      deep: true,
      immediate: false,
      handler(val) {
        if (val) {
          console.log('tupe', val);
          this.productType = val;
        }
      },
    },
  },
  created() {
    console.log(this.disabled);
    this.getDioct();
  },
  mounted() {
  },
};
</script>

<style scoped lang="less">
.table-top {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    margin-left: -100px;
}

.list_content {
    margin-left: -50px;

    .list_item {
        margin: 20px 0 30px 0;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 20px;
        box-sizing: border-box;
    }

    .list_item:last-child {
        border: none;
    }
}

/deep/.vxe-header--column .vxe-cell--title {
    line-height: inherit !important;
}

/deep/ .el-form-item__content {
    flex: 1;
    display: flex;
}

/deep/ .el-upload--picture-card {
    width: 100px !important;
    height: 100px !important;
    line-height: 110px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px !important;
    height: 100px !important;
}
</style>
